import React, {Component} from 'react';
import './styles.css';
import CardHelper from "../../helpers";
import { getCoverStyle, isPS4Platform, clearCoverRef } from '../ps4ImageUtils';

const _isPS4 = isPS4Platform();

class CardMorePopular extends Component {
  constructor(props) {
    super(props);
    this.state = { imageReady: !_isPS4 };
    this._coverRef = null;
    this._loadTimer = null;

    this._setCoverRef = this._setCoverRef.bind(this);

    // Cache
    this._cachedBadge = null;
    this._cachedCoverStyle = null;
    this._prevBadges = undefined;
    this._prevPortrait = undefined;
    this._prevImageReady = undefined;
  }

  componentDidMount() {
    if (!this.state.imageReady) {
      this._loadTimer = setTimeout(this._onImageReady, _isPS4 ? 200 : 150);
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    return (
      this.props.cover !== nextProps.cover ||
      this.props.portrait !== nextProps.portrait ||
      this.props.badges !== nextProps.badges ||
      this.props.classOutLineFocus !== nextProps.classOutLineFocus ||
      this.state.imageReady !== nextState.imageReady
    );
  }

  componentWillUnmount() {
    if (this._loadTimer) {
      clearTimeout(this._loadTimer);
      this._loadTimer = null;
    }
    clearCoverRef(this._coverRef);
    this._coverRef = null;
    this._cachedBadge = null;
    this._cachedCoverStyle = null;
  }

  _onImageReady = function() {
    this.setState({ imageReady: true });
  }.bind(this);

  _setCoverRef(el) {
    this._coverRef = el;
  }

  render() {
    const portrait = this.props.portrait;
    const badges = this.props.badges;
    const imageReady = this.state.imageReady;

    if (portrait !== this._prevPortrait || imageReady !== this._prevImageReady) {
      this._prevPortrait = portrait;
      this._prevImageReady = imageReady;
      this._cachedCoverStyle = getCoverStyle(portrait, imageReady);
    }

    if (badges !== this._prevBadges) {
      this._prevBadges = badges;
      this._cachedBadge = CardHelper.createBadge(badges);
    }

    return (
      <div className={'card card-popular ' + (this.props.classOutLineFocus || '')}>
        <div className={'card-container'}>
          <div className={'preview-container'}>
            {this.props.cover !== '' &&
            <div
              ref={this._setCoverRef}
              className='card-cover'
              style={this._cachedCoverStyle}
            />
            }
            {this._cachedBadge}
          </div>
        </div>
      </div>
    );
  }
}

export default CardMorePopular;



// WEBPACK FOOTER //
// ./src/components/CardNew/cardTypes/CardMorePopular/index.js